import React from "react";
import { useParams } from "react-router";

import { PageLoader } from "@/components/PageLoader";
import { getJobByNameQueryOptions, Job } from "../queries/job-by-name";
import { useTrackedQuery } from "@/hooks/useTrackedQuery";

export type SalesOrderTrackerRouteParams = "jobNumber";

export interface WithJobProps {
  job: Job;
}

/**
 * Higher-Order Component to fetch the selected job for the current navigation route. A loading screen is displayed while
 * the job is loading, then the job is passed to the wrapped component.
 */
export const withJob = <P extends object>(WrappedComponent: React.FC<WithJobProps & P>) => {
  return function WithJob(props: P) {
    const jobNumber = useParams<SalesOrderTrackerRouteParams>().jobNumber!;
    const jobQuery = useTrackedQuery(getJobByNameQueryOptions(jobNumber));

    if (jobQuery.isError) return `Error loading job: ${jobQuery.error.message}`;
    if (jobQuery.isPending) return <PageLoader text="Loading job" />;

    return <WrappedComponent job={jobQuery.data} {...props} />;
  };
};
